import React, { useEffect, useState, useMemo } from 'react';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { useParams } from 'react-router-dom';

// import 'react-vertical-timeline-component/style.min.css';
import moment from 'moment';
import axios from 'axios';
import styles from './index.module.scss';

const mqtt = require('mqtt');

const mqurl = 'ws://192.168.0.201:11883';
let mqttConnect;
// const cid = 'A001';

const BroadcastFrontDesk = () => {
  const handle = useFullScreenHandle();
  const { id } = useParams();
  const [broadcastData, setBroadcastData] = useState([]);
  const [oldbroadcastData, setOldBroadcastData] = useState([]);
  const [weather, setWeather] = useState('');
  const [newArr, setNewArr] = useState([]);
  const [time, setTime] = useState('');

  // mqtt 接收
  // const onBroadcast = (sText) => {
  //   const broadcast = JSON.parse(sText);
  //   setBroadcastData(broadcast);
  //   console.log(broadcast);
  // };
  useEffect(() => {
    mqttConnect = mqtt.connect(mqurl, {
      username: 'ezcon',
      password: 'ezmqtt',
    }); //
    mqttConnect.subscribe(`EZBroadcast/Info/${id}/#`, (err) => {
      if (err) {
        console.log('==mqtt subscribe err:', err);
      }
    });
    mqttConnect.on('connect', () => {
      console.log('==mqtt connectd to ', mqurl);
    });
    mqttConnect.on('message', (topics, payload) => {
      console.log('==mqtt topics:', topics, ',payload:', payload.toString());
      console.log(JSON.parse(payload.toString()));
      setBroadcastData(JSON.parse(payload.toString()));
    });

    return () => {
      if (mqttConnect) {
        mqttConnect.end();
      }
    };
  }, [id]);

  useEffect(() => {
    const newTime = setInterval(() => setTime(new Date()), 1000);
    return () => {
      clearInterval(newTime);
    };
  }, []);

  // const broadcastInterval = useMemo(() => {
  //   const interval = {
  //     id: null,
  //     startInterval() {
  //       interval.id = setInterval(() => {

  //       }, 1000);
  //     },
  //     stopInterval() {
  //       clearInterval(interval.id);
  //     },
  //   };
  //   return interval;
  // }, []);

  useEffect(() => {
    // setNewArr([]);
    if (broadcastData.hasOwnProperty('title')) {
      console.log(broadcastData);
      // let Interval = '';
      const TimeArr = [];

      for (let i = 0; i < broadcastData.content.length; i++) {
        if (
          broadcastData.content[i].children &&
          broadcastData.content[i].children.length > 0
        ) {
          TimeArr[i] = broadcastData.content[i].children[0];
        } else {
          TimeArr[i] = {};
        }
      }
      setNewArr(TimeArr);

      for (let i = 0; i < broadcastData.content.length; i++) {
        // console.log(
        //   broadcastData.content[i].children.length,
        //   '===children.length'
        // );
        if (
          broadcastData.content[i].children &&
          broadcastData.content[i].children.length > 0
        ) {
          let totalTime = 0;
          const { unit, seconds } = broadcastData.content[i].children[0];
          if (broadcastData.content[i].carousel) {
            // 有重複輪播
            let k = 1;
            let num = 0;
            if (unit === 'm') {
              totalTime = seconds * 60;
            } else {
              totalTime = seconds;
            }

            // useMemo(() => {
            // if (oldbroadcastData.id !== broadcastData.id) {
            //   clearInterval(oldbroadcastData.id);
            // }
            setInterval(() => {
              // if (oldbroadcastData !== broadcastData) {
              //   k = 0;
              //   totalTime = 0;
              // }
              if (k === totalTime) {
                console.log('tokkk');
                if (num === broadcastData.content[i].children.length - 1) {
                  num = -1;
                  totalTime =
                    broadcastData.content[i].children[
                      broadcastData.content[i].children.length - 1
                    ].seconds - 1;
                  k = 0;
                }
                if (broadcastData.content[i].children.length > 1) {
                  console.log(num, '===num');
                  TimeArr[i] = broadcastData.content[i].children[num + 1];
                } else {
                  TimeArr[i] = {};
                  TimeArr[i] = broadcastData.content[i].children[0];
                }

                console.log(TimeArr);
                setNewArr(TimeArr.map((x) => ({ ...x })));
                // clearInterval(oldbroadcastData.id);
                // setOldBroadcastData(broadcastData);
                num += 1;
                if (unit === 'm') {
                  totalTime +=
                    broadcastData.content[i].children[num].seconds * 60;
                } else {
                  totalTime += broadcastData.content[i].children[num].seconds;
                }
              }
              k++;
              console.log(k);
              console.log(totalTime);
            }, 1000);
            // }, []);
          } else {
            // 無重複輪播
            for (let j = 0; j < broadcastData.content[i].children.length; j++) {
              if (broadcastData.content[i].children[j].unit === 'm') {
                totalTime +=
                  broadcastData.content[i].children[j].seconds * 1000 * 60;
              } else {
                totalTime +=
                  broadcastData.content[i].children[j].seconds * 1000;
              }
              broadcastData.id = setTimeout(() => {
                if (j + 1 < broadcastData.content[i].children.length) {
                  TimeArr[i] = broadcastData.content[i].children[j + 1];
                }
                console.log(TimeArr);
                setNewArr(TimeArr.map((x) => ({ ...x })));
                // clearInterval(oldbroadcastData.id);
                // setOldBroadcastData(broadcastData);
              }, totalTime);
            }
          }
        } else {
          TimeArr[i] = {};
        }
        // return clearInterval(Interval);
      }
      console.log(TimeArr);
    }
  }, [broadcastData]);
  // console.log(oldbroadcastData, '===oldbroadcastData');
  // console.log(newArr);
  // useEffect(() => {
  //   console.log(oldbroadcastData);
  //   if (oldbroadcastData.hasOwnProperty('id')) {
  //     clearInterval(oldbroadcastData.id);
  //     console.log('hihihi');
  //   }
  // }, [oldbroadcastData]);
  const onSetWeather = (city) => {
    axios(`/ezcon/api/getWeather?city=${city}`, {
      method: 'GET',
    }).then((res) => {
      // weatherData = res.data;
      setWeather(res.data.今天.天氣);
      // return res.data.今天.天氣;
    });
  };

  const onSetStyle = (children) => {
    // console.log(children);
    if (children.typeContent === 'weather') {
      onSetWeather(children.typeFormat);
    }

    return (
      <div
        className={styles.showAddText}
        style={{
          display: 'flex',
          height: '100%',
          width: '100%',
          fontSize: children.textSize,
          color: children.textColor,
          fontWeight: children.textTags.indexOf('粗體') >= 0 ? '900' : 'normal',
          fontStyle:
            children.textTags.indexOf('斜體') >= 0 ? 'italic' : 'normal',
          justifyContent: children.textLevel,
          alignItems:
            (children.textVertical === 'start' && 'flex-start') ||
            (children.textVertical === 'center' && 'center') ||
            (children.textVertical === 'end' && 'flex-end'),
          overflow: 'hidden',
          backgroundImage:
            (children.typeContent === 'image' &&
              `url(${children.typeFormat})`) ||
            'none',
          backgroundSize:
            (children.textSize === 'fullVersion' && 'cover') ||
            (children.textSize === 'originalSize' && 'Contain') ||
            (children.textSize === 'repeat' && 'Contain'),
          backgroundRepeat:
            children.textSize === 'repeat' ? 'repeat' : 'no-repeat',
          backgroundPosition: children.textLevel,
        }}
      >
        {(children.typeContent === 'date' ||
          children.typeContent === 'time' ||
          children.typeContent === 'dateTime') &&
          moment(time).format(children.typeFormat)}
        {children.typeContent === 'text' &&
          children.typeFormat.split('\n').map((i) => (
            <>
              {i}
              <br />
            </>
          ))}
        {children.typeContent === 'weather' &&
          `${children.typeFormat}天氣，${weather}`}
      </div>
    );
  };

  if (newArr.length > 0 && broadcastData.hasOwnProperty('title')) {
    if (newArr.length === broadcastData.content.length) {
      if (broadcastData.template === 'one') {
        return (
          <FullScreen handle={handle}>
            <div className={styles.BroadcastFrontDesk} onClick={handle.enter}>
              <div className={styles.templateTop}>
                {broadcastData.content.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        width: `${item.size}%`,
                        backgroundColor: item.color,
                        height: '100%',
                      }}
                    >
                      {item.children !== undefined && newArr.length > 0
                        ? onSetStyle(newArr[index])
                        : '未設定內容'}
                    </div>
                  );
                })}
              </div>
            </div>
          </FullScreen>
        );
      } else if (broadcastData.template === 'two') {
        return (
          <FullScreen handle={handle}>
            <div className={styles.BroadcastFrontDesk} onClick={handle.enter}>
              <div className={styles.templateTop}>
                {broadcastData.content.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={styles.templateTwo}
                      style={{
                        width: `${item.size}%`,
                        backgroundColor: item.color,
                        height: '100%',
                      }}
                    >
                      {item.children !== undefined && newArr.length > 0
                        ? onSetStyle(newArr[index])
                        : '未設定內容'}
                    </div>
                  );
                })}
              </div>
            </div>
          </FullScreen>
        );
      } else if (broadcastData.template === 'three') {
        return (
          <FullScreen handle={handle}>
            <div className={styles.BroadcastFrontDesk} onClick={handle.enter}>
              <div className={styles.templateContent}>
                {broadcastData.content.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={styles.templateTwo}
                      style={{
                        height: `${item.size}%`,
                        backgroundColor: item.color,
                        width: '100%',
                      }}
                    >
                      {item.children !== undefined && newArr.length > 0
                        ? onSetStyle(newArr[index])
                        : '未設定內容'}
                    </div>
                  );
                })}
              </div>
            </div>
          </FullScreen>
        );
      } else if (
        broadcastData.template === 'four' &&
        broadcastData.content.length === 3
      ) {
        return (
          <FullScreen handle={handle}>
            <div className={styles.BroadcastFrontDesk} onClick={handle.enter}>
              <div className={styles.templateContent} style={{ border: 0 }}>
                <div
                  className={styles.templateTop}
                  style={{
                    height: `${100 - broadcastData.content[2].size}%`,
                    width: '100%',
                    border: 0,
                  }}
                >
                  {broadcastData.content.map((item, index) => {
                    if (index !== 2) {
                      return (
                        <div
                          key={index}
                          className={styles.templateTwo}
                          style={{
                            width: `${item.size}%`,
                            backgroundColor: item.color,
                            height: '100%',
                          }}
                        >
                          {item.children !== undefined && newArr.length > 0
                            ? onSetStyle(newArr[index])
                            : '未設定內容'}
                        </div>
                      );
                    } else {
                      return null;
                    }
                  })}
                </div>
                <div
                  className={styles.templateBottom}
                  style={{ height: `${broadcastData.content[2].size}%` }}
                >
                  <div
                    key={2}
                    className={styles.templateTwo}
                    style={{
                      width: '100%',
                      backgroundColor: broadcastData.content[2].color,
                      height: '100%',
                    }}
                  >
                    {broadcastData.content[2].children !== undefined &&
                    newArr.length > 0
                      ? onSetStyle(newArr[2])
                      : '未設定內容'}
                  </div>
                </div>
              </div>
            </div>
          </FullScreen>
        );
      } else {
        return (
          <FullScreen handle={handle}>
            <div className={styles.BroadcastFrontDesk} onClick={handle.enter}>
              未設定播放內容
            </div>
          </FullScreen>
        );
      }
    } else {
      return (
        <FullScreen handle={handle}>
          <div className={styles.BroadcastFrontDesk} onClick={handle.enter}>
            未設定播放內容
          </div>
        </FullScreen>
      );
    }
  } else {
    return (
      <FullScreen handle={handle}>
        <div className={styles.BroadcastFrontDesk} onClick={handle.enter}>
          未設定播放內容
        </div>
      </FullScreen>
    );
  }
};

export default BroadcastFrontDesk;
